export var Spacer;
(function (Spacer) {
    Spacer["XXS"] = "4px";
    Spacer["XS"] = "8px";
    Spacer["S"] = "12px";
    Spacer["M"] = "20px";
    Spacer["L"] = "32px";
    Spacer["XL"] = "40px";
    Spacer["XXL"] = "80px";
})(Spacer || (Spacer = {}));
//# sourceMappingURL=index.js.map